import { useContext } from 'react';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import AllAccessGuestI from '../../interfaces/AllAccessGuest';
import GlobalContextI from '../../interfaces/GlobalContext';
import GlobalContext from '../../contexts/GlobalContext';
import Container from '../../components/Container';
import Header from '../../components/Header';
import FlexContainer from '../../components/FlexContainer';
import Button from '../../components/Button';
import parseDate from '../../functions/parseDate';

type LocationState = {
    matches?: AllAccessGuestI[];
    query?: string;
};

const StageNameMatchesPage = () => {
    const history = useHistory();
    const location = useLocation<LocationState>();
    const { type }: { type: string } = useParams();
    const { setGuest } = useContext<GlobalContextI>(GlobalContext);

    const matches = location.state?.matches ?? [];
    const query = location.state?.query ?? '';

    const selectMatch = (guest: AllAccessGuestI) => {
        setGuest(guest);
        history.push(`/guests/checkin/${type}/${guest.guestID}/update`);
    };

    return (
        <Container containerName={'landing'}>
            <Header
                title={'Select Guest'}
                subtitle={
                    query
                        ? `Stage name "${query}" — ${matches.length} match${
                              matches.length === 1 ? '' : 'es'
                          }, most recent first`
                        : 'Please select a guest to check in'
                }
                padding={true}
            />
            <FlexContainer>
                {matches.length === 0 ? (
                    <div className="landing-container__text">
                        <p>
                            No matches available. Go back and search again.
                        </p>
                    </div>
                ) : (
                    matches.map((match) => {
                        const lastEntry =
                            match.entryDates && match.entryDates.length > 0
                                ? parseDate(
                                      match.entryDates[
                                          match.entryDates.length - 1
                                      ]
                                  )
                                : 'No visits yet';
                        return (
                            <div key={match._id}>
                                <div className="landing-container__text">
                                    <p>
                                        <strong>
                                            {match.stageName.toUpperCase()}
                                        </strong>
                                        {' — '}
                                        {match.firstName} {match.lastName}
                                        {' — Last visit: '}
                                        {lastEntry}
                                    </p>
                                </div>
                                <Button
                                    color={'green'}
                                    margin={true}
                                    onClick={() => selectMatch(match)}
                                >
                                    Select
                                </Button>
                            </div>
                        );
                    })
                )}
                <Button
                    color={'red'}
                    margin={true}
                    onClick={() => history.push(`/guests/checkin/${type}`)}
                >
                    Back
                </Button>
            </FlexContainer>
        </Container>
    );
};

export default StageNameMatchesPage;
